import { createFileRoute, redirect } from '@tanstack/react-router';
import { getAuthStore } from '../main';
import { SpSidebar } from '../components/Sidebar';
import { Pane } from '@sheridan-prize/ui';
import { ArtworkEdit } from '../components/ArtworkEdit';

export const Route = createFileRoute('/artworks_/$artworkId')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
    const isAuthenticated = getAuthStore().getIsAuthenticated();
    const userRole = getAuthStore().getUser()?.role;

    if (!isAuthenticated) {
      throw redirect({ to: '/login' });
    }

    if (userRole !== 'superadmin' && userRole !== 'admin') {
      throw redirect({ to: '/' });
    }

    await getAuthStore().fetchUserDoc();
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { artworkId } = Route.useParams();

  return (
    <>
      <SpSidebar />
      <Pane tag="main" classes={'sp-main'}>
        <h1>Edit Artwork</h1>
        <ArtworkEdit artworkId={artworkId} />
      </Pane>
    </>
  );
}
